/**
 * Lightweight conversion analytics helper — RGPD-friendly (no cookies).
 * Stores a session UUID in sessionStorage (cleared on tab close)
 * and posts events to /api/analytics/track.
 */
import api from './api';

const SESSION_KEY = 'devisgo_session_id';

function getOrCreateSessionId() {
  if (typeof window === 'undefined') return '';
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) ||
      `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

function readUTM() {
  if (typeof window === 'undefined') return {};
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source') || '',
    utm_medium: params.get('utm_medium') || '',
    utm_campaign: params.get('utm_campaign') || '',
  };
}

export async function trackEvent(event, properties = {}) {
  try {
    const sid = getOrCreateSessionId();
    await api.post('/analytics/track', {
      event,
      page: window.location.pathname,
      referrer: document.referrer || '',
      session_id: sid,
      properties,
      ...readUTM(),
    });
  } catch (e) {
    // Silent — analytics must never break the UX.
  }
}

export function getSessionId() {
  return getOrCreateSessionId();
}
